import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedSideMenuContent(): Provider {
  return provideTranslocoScope({
    scope: 'side-menu',
    alias: 'appSm',
    loader: i18nLoader,
  });
}
